import { handleActions } from "redux-actions";
import { push } from "react-router-redux";
import { initialize as initializeForm } from "redux-form";
import { ToastStore } from "react-toasts";
import Swal from "sweetalert2";
import { getMe } from "../usuario/usuario";
import { api } from "api";

// ------------------------------------
// Constants
// ------------------------------------
export const INGRESO_DOCUMENTO = "INGRESO_DOCUMENTOS_INGRESO_DOCUMENTO";
export const INGRESO_DOCUMENTOS = "INGRESO_DOCUMENTOS_INGRESO_DOCUMENTOS";
export const PAGE = "INGRESO_DOCUMENTOS_PAGE";
export const BUSCADOR = "INGRESO_DOCUMENTOS_BUSCADOR";
export const SORT = "INGRESO_DOCUMENTOS_SORT";
export const LOADER = "INGRESO_DOCUMENTOS_LOADER";

export const constants = {};

const endpoint = "ingreso_documentos";
// ------------------------------------
// Actions
// ------------------------------------
export const listar =
    (page = 1) =>
    (dispatch, getStore) => {
        dispatch(setLoader(true));
        const store = getStore();
        const ingreso_documentos = store.ingreso_documentos;
        const { ordering, search } = ingreso_documentos;
        api.get(endpoint, { page, ordering, search })
            .then((data) => {
                if (data) {
                    dispatch(setDocumentos(data));
                }
                dispatch(setPage(page));
            })
            .catch((err) => {})
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

export const buscar = (search) => (dispatch) => {
    dispatch(setBuscador(search));
    dispatch(listar());
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.ingreso_documentos.page;
    dispatch(listar(page));
};

export const crear = (data) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(endpoint, data)
        .then((resp) => {
            ToastStore.success("Datos almacenados correctamente");
            dispatch(push("/ingreso_documentos"));
        })
        .catch((err) => {
            Swal(
                "ERROR",
                "Ha ocurrido un error, verifique los datos y vuelva a intentar.",
                "error"
            );
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${endpoint}/${id}`)
        .then((resp) => {
            dispatch(setDocumentoLeer(resp));
        })
        .catch((err) => {
            Swal("ERROR", "Ha ocurrido un error.", "error");
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));
    api.put(`${endpoint}/${id}`, data)
        .then((resp) => {
            ToastStore.success("Datos almacenados correctamente");
            dispatch(push("/ingreso_documentos"));
        })
        .catch((err) => {
            const msj = err.error
                ? err.error
                : "Ha ocurrido un error, verifique los datos y vuelva a intentar.";
            Swal("ERROR", msj, "error");
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${endpoint}/${id}`)
        .then((data) => {
            ToastStore.success("Registro eliminado.");
            dispatch(listar());
        })
        .catch((err) => {
            const msj = err.error
                ? err.error
                : "Ha ocurrido un error, verifique los datos y vuelva a intentar.";
            Swal("ERROR", msj, "error");
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

// ------------------------------------
// PureActions
// ------------------------------------
export const setDocumentos = (data) => ({
    type: INGRESO_DOCUMENTO,
    data,
});
export const setPage = (page) => ({
    type: PAGE,
    page,
});
export const setBuscador = (search) => ({
    type: BUSCADOR,
    search,
});
export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});
export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});
export const setDocumentoLeer = (ingreso_documentos) => ({
    type: INGRESO_DOCUMENTOS,
    ingreso_documentos,
});

export const actions = {
    listar,
    buscar,
    sortChange,
    eliminar,
    crear,
    editar,
    leer,
};

// ------------------------------------
// Reducers
// ------------------------------------
export const reducers = {
    [INGRESO_DOCUMENTO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [INGRESO_DOCUMENTOS]: (state, { ingreso_documentos }) => {
        return {
            ...state,
            ingreso_documentos,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [BUSCADOR]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    ingreso_documentos: {},
    page: 1,
    search: "",
    ordering: "",
    loader: false,
};

export default handleActions(reducers, initialState);
